import { CopilotDraftBanner } from './CopilotDraftBanner';

interface EditorRef {
  current: { insertMarkdown: (markdown: string) => void } | null;
}

interface Props {
  report?: { uuid?: string } | null;
  editorRef: EditorRef;
}

/**
 * Report-side entry point for the copilot conclusion draft. Renders the banner
 * (which is itself a no-op until a draft is staged) and inserts the accepted
 * markdown into the given editor. Kept as a thin wrapper so the Report
 * component only needs a single line to opt in.
 */
export function CopilotDraft({ report, editorRef }: Props) {
  if (!report?.uuid) return null;
  return (
    <CopilotDraftBanner
      reportUuid={report.uuid}
      section="conclusion"
      onAccept={(md) => editorRef.current?.insertMarkdown(md)}
    />
  );
}
